import React from 'react';
import { useSelector } from 'react-redux';

import { Col } from '../../components/layout/layout';
// import SonarTable from '../SonarTable';
import SonarTable from '../sonar-table/SonarTable';

function DedicatedTableColumn({ columnsToShow, initialSort, rankLabel, rankKey }) {
  const isShowDedicated = useSelector((state) => state.sonarDashboard.isShowDedicated);

  if (!isShowDedicated) {
    return null;
  }

  return (
    <Col width={25} className='sonar-dashboard_dedicated-table'>
      <SonarTable
        columnsToShow={columnsToShow}
        initialSort={initialSort}
        rankLabel={rankLabel}
        rankKey={rankKey}
        isDedicated
      />
    </Col>
  );
}

export default DedicatedTableColumn;
